module.exports = __webpack_public_path__ + "img/bv-app-store-new-stop.d86bd812.png";